import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { LANGUAGES, translations } from "./translations";

const LanguageContext = createContext(null);

const getNestedValue = (source, path) =>
   path.split(".").reduce((value, key) => value?.[key], source);

export function LanguageProvider({ children }) {
   const [language, setLanguageState] = useState(() => {
      if (typeof window === "undefined") return "EN";
      return localStorage.getItem("language") || "EN";
   });

   const setLanguage = (code) => {
      const next = LANGUAGES.includes(code) ? code : "EN";
      setLanguageState(next);
      if (typeof window !== "undefined") {
         localStorage.setItem("language", next);
      }
   };

   useEffect(() => {
      document.documentElement.lang = language.toLowerCase();
   }, [language]);

   const value = useMemo(() => {
      const t = (path, fallback = "") =>
         getNestedValue(translations[language], path) ??
         getNestedValue(translations.EN, path) ??
         fallback;

      return { language, languages: LANGUAGES, setLanguage, t };
   }, [language]);

   return (
      <LanguageContext.Provider value={value}>
         {children}
      </LanguageContext.Provider>
   );
}

export function useTranslation() {
   const context = useContext(LanguageContext);
   if (!context) {
      throw new Error("useTranslation must be used inside LanguageProvider");
   }
   return context;
}
